import { render, staticRenderFns } from "./FormBodyCol.vue?vue&type=template&id=b98910fe&scoped=true"
import script from "./FormBodyCol.vue?vue&type=script&lang=js"
export * from "./FormBodyCol.vue?vue&type=script&lang=js"
import style0 from "./FormBodyCol.vue?vue&type=style&index=0&id=b98910fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98910fe",
  null
  
)

export default component.exports